import React from 'react';
export function Hero() {
  return <section className="relative w-full min-h-[28vh] md:min-h-[70vh] flex items-center justify-center px-4 py-0 md:py-6" data-id="element-165">
      {/* Background gradient — no absolute positioning needed, use pseudo or keep lightweight */}
      <div className="absolute inset-0 gradient-overlay pointer-events-none" data-id="element-166" />

      <div className="max-w-5xl mx-auto text-center relative z-10" data-id="element-167">
        <h1 className="text-xl md:text-5xl lg:text-6xl font-black text-[var(--text-light)] mb-2 md:mb-4 tracking-tight leading-tight" data-id="element-168">
          CONVIÉRTETE EN
          <br data-id="element-169" />
          <span className="text-[var(--accent-orange)]" data-id="element-170">
            MENOS DE 7 DÍAS
          </span>{' '}
          EN UNA EXPERTA EN JABONES ARTESANALES Y COMIENZA TU
          <br data-id="element-171" />
          <span className="text-[var(--accent-orange)]" data-id="element-172">
            PROPIO NEGOCIO RENTABLE
          </span>{' '}
          EN CASA
        </h1>
      </div>
    </section>;
}